<template>
  <div>
    <div class="columns">
      <div class="column">
        <!-- <b-select v-model="perPage" size="is-small">
              <option v-for="(p, index) in pageList" v-bind:key="index" :value="p">{{p}} per page</option>
            </b-select> -->
      </div>
      <div class="column">
        <b-field>
          <b-input
            v-model="searchTable"
            :placeholder="placeholder"
            size="is-small"
          ></b-input>
        </b-field>
      </div>
    </div>
    <b-table
      :data="tableData"
      :bordered="bordered"
      :checkable="checkable"
      :striped="striped"
      :narrowed="narrowed"
      :hoverable="hoverable"
      :mobile-cards="mobileCards"
      :loading="loading"
      :current-page.sync="selectedPage"
      paginated
      backend-pagination
      :per-page="perPage"
      :total="totalData"
      @page-change="onPageChange"
      :checked-rows.sync="newCheckedRows"
    >
      <template slot-scope="props">
        <slot name="row-content" :item="props"></slot>
      </template>
      <template slot="empty">
        <slot name="empty"></slot>
      </template>
    </b-table>
  </div>
</template>
<script>
export default {
  props: [
    "tableData",
    "bordered",
    "striped",
    "narrowed",
    "hoverable",
    "mobileCards",
    "loading",
    "totalData",
    "perPage",
    "search",
    "page",
    "placeholder",
    "checkable",
  ],
  mounted() {
    this.searchTable = this.search;
  },
  methods: {
    onPageChange(page) {
      this.$emit("onPageChanged", page);
    },
  },
  data: () => ({
    pageList: [10, 15, 20, 50],
    searchTable: "",
    selectedPage: 1,
    newCheckedRows: [],
  }),
  watch: {
    newCheckedRows() {
      this.$emit("checkedRowsChanged", this.newCheckedRows);
    },
    selectedPage(val) {
      this.$emit("onPageChanged", val);
    },
    searchTable(val) {
      this.$emit("onSearchChanged", val);
    },
    perPage(val) {
      this.$emit("onPerPageChanged", val);
    },
  },
};
</script>

